const getDateWithTimeZone = dateTime => {
  const date = new Date(dateTime);
  const offset = date.getTimezoneOffset();
  const difference = offset === 0 ? 0 : offset * -1;
  const isDifferenceUnderZero = difference < 0;

  const zoneDate = new Date('0001-01-01T00:00:00');
  zoneDate.setMinutes(difference);
  const zoneTime = zoneDate.toTimeString();
  const zoneDifference = zoneTime.substring(0, 5);

  return `${dateTime}${isDifferenceUnderZero ? '-' : '+'}${zoneDifference}`;
};

export default getDateWithTimeZone;
